import React from 'react';
import {Grid, Paper, Typography} from '@mui/material';
import {styled} from "@mui/material/styles";

const RowGapContainer = styled(Grid)(() => ({
  rowGap: '0.29em',
}));

interface SimpleInfoPanelProps {
  title?: string;
  content?: React.ReactNode;
  children?: React.ReactNode;

  [key: string]: any;
}

const SimpleInfoPanel: React.FC<SimpleInfoPanelProps> = (props) => {
  const {title, content, children, ...remainingProps} = props;

  return (
    <Paper {...remainingProps} component='section'>
      <RowGapContainer container direction='column'>
        {title && <Typography variant='h6' color='textPrimary'>{title}</Typography>}
        {content}
      </RowGapContainer>
      {children}
    </Paper>
  );
};

export default SimpleInfoPanel;
